import React from 'react';
import { CalendarPlus } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { buildEvent, googleUrl, downloadIcs } from '../lib/calendar';

export const AddToCalendar = ({ day, item, testId }) => {
  const ev = buildEvent(day, item);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={`Add ${item.title} to calendar`} className="text-gold/70 hover:text-gold transition-colors p-1" data-testid={testId}>
          <CalendarPlus size={15} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-cbtu-navy border-gold/30 text-cbtu-cream">
        <DropdownMenuItem asChild data-testid={`${testId}-google`}>
          <a href={googleUrl(ev)} target="_blank" rel="noopener noreferrer">Google Calendar</a>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => downloadIcs([ev], 'cbtu-r3-event.ics')} data-testid={`${testId}-ics`}>
          Apple / Outlook (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const AddFullConference = ({ agenda }) => (
  <button
    type="button"
    onClick={() => downloadIcs(agenda.flatMap((d) => d.items.map((it) => buildEvent(d, it))), 'cbtu-region-iii-2026-conference.ics')}
    className="ghost-button px-5 py-2.5 rounded-sm text-sm inline-flex items-center gap-2"
    data-testid="agenda-add-all-calendar-btn"
  >
    <CalendarPlus size={14} /> Add Full Agenda to Calendar
  </button>
);
